export class ZoneSelect {
    constructor(
        public libelle?: string,
        public regionInseeId?: string,
        public depInseeId?: string
    ) {
    }
}
